import { useState } from 'react';
import { toast } from 'react-toastify';

import { SaveNumberModal } from '../SaveNumberModal';

const EMPTY_STRING = '';

export const FinishCallModal = ({
  open,
  contact,
  phoneNumber,
  onChangeContact,
  updateDialOutcomes,
  onClose,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onAccept = async () => {
    setIsSubmitting(true);
    const defaultValues = {
      contactId: contact.contactId,
      company: contact.company,
      contact: contact.contact ?? EMPTY_STRING,
      title: contact.title ?? EMPTY_STRING,
      industry: contact.industry ?? EMPTY_STRING,
      country: contact.country ?? EMPTY_STRING,
      state: contact.state ?? EMPTY_STRING,
      city: contact.city ?? EMPTY_STRING,
      address: contact.address ?? EMPTY_STRING,
      website: contact.website ?? EMPTY_STRING,
      email: contact.email ?? EMPTY_STRING,
      linkedin: contact.linkedin ?? EMPTY_STRING,
    };

    try {
      const response = await fetch('/call-contact-update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...defaultValues,
          phoneNumbersToAdd: [{ phoneNumber, isBestPhoneNumber: 0 }],
        }),
      });

      if (response.status !== 200) throw new Error();

      const data = await response.json();

      onChangeContact({
        ...contact,
        phoneNumbers: data.record.PhoneNumbers,
      });
      setIsSubmitting(false);
      onClose();
      updateDialOutcomes();
    } catch {
      toast.error('Phone Number not saved!', {
        position: 'top-right',
        autoClose: 3000,
      });
      setIsSubmitting(false);
      onClose();
      updateDialOutcomes();
    }
  };

  const onReject = () => {
    onClose();
    updateDialOutcomes();
  };

  return (
    <SaveNumberModal
      open={open}
      onClose={onClose}
      disabled={isSubmitting}
      onAccept={onAccept}
      onReject={onReject}
    />
  );
};
